import React from 'react'

const Header = () => {
  return (
    <h2>
      <span>Tasknage</span>
      <span>Your Personal Task-Manager Web App</span>
    </h2>
  )
}

export default Header